import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EventEmitter } from 'events';
import { sortBy } from 'lodash';

import { t } from '../../../../../modules/infra/i18n';
import {
  getAppointments,
} from '../../actions';
import {
  getStartOfDay,
} from '../../../../common/helpers/times';
import {
  getDate,
  filteredAppointments,
} from '../../appointmentSelector';
import AppointmentsWrapper from '../../appointmentsWrapper';
import AppointmentsListDay from './appointmentsListDay/appointmentsListDay';
import { USER_TYPES } from '../../../../auth/constants';

class AppointmentsList extends Component {

  componentWillMount() {
    this.fetch();
  }

  componentDidMount() {
    EventEmitter.prototype.on('appointment-saved', this.fetch);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentDate !== this.props.currentDate && nextProps.currentDate) {
      this.fetch({ currentDate: nextProps.currentDate });
    }
  }

  componentWillUnmount() {
    EventEmitter.prototype.removeListener('appointment-saved', this.fetch);
  }

  fetch = (params) => {
    const {
      getAppointments,
      shop,
      timezone,
      currentDate,
      user,
      barberUser,
    } = {
      ...this.props,
      ...params,
    };

    const filters = {
      dateTime__gte: getStartOfDay(timezone, currentDate).toJSON(),
      dateTime__lte: getStartOfDay(timezone, currentDate).endOf('day').toJSON(),
    };

    switch (user.kind) {
      case USER_TYPES.shop:
        getAppointments(shop, filters);
        break;
      case USER_TYPES.barber:
        filters.barberId = barberUser.id;
        getAppointments(barberUser.shopId, filters);
        break;
    }
  }

  render() {
    const {
      appointments,
    } = this.props;
    let list = (
      <h3 className="u-mt++ u-text-center">{t('appointment:list.no_appointments_found')}</h3>
    );

    if (appointments && appointments.length) {
      const earliestToLatest = sortBy(appointments, 'start');
      list = <AppointmentsListDay appointments={earliestToLatest} />;
    }

    return (
      <AppointmentsWrapper
        currentView="list"
        appointmentsLength={appointments.length}
      >
        <div className="c-appointments u-p0 u-mt">
          { list }
        </div>
      </AppointmentsWrapper>
    );
  }
}

AppointmentsList.propTypes = {
  currentDate: PropTypes.string.isRequired,
  appointments: PropTypes.arrayOf(PropTypes.object).isRequired,
  getAppointments: PropTypes.func.isRequired,
  shop: PropTypes.string,
  timezone: PropTypes.string.isRequired,
  user: PropTypes.object,
  barberUser: PropTypes.object,
};

const mapStateToProps = state => ({
  currentDate: getDate(state),
  timezone: state.auth.timezone,
  shop: state.auth.shop,
  appointments: filteredAppointments(state),
  user: state.auth.user,
  barberUser: state.auth.barberUser,
});

const mapDispatchToProps = {
  getAppointments,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentsList);
